import React from 'react';
import './HowItWorks.css';
import { NetworkIcon, FlashIcon, ShieldIcon } from './Icons';

const HowItWorks = () => {
  const steps = [
    {
      icon: <NetworkIcon size={48} color="#00d4ff" />,
      number: '01',
      title: 'Select Your Network',
      description: 'Choose your preferred cryptocurrency network from Polygon, TRC20, ERC20, or BEP20. Each network offers fast and secure transactions.'
    },
    {
      icon: <FlashIcon size={48} color="#00d4ff" />,
      number: '02',
      title: 'Enter Order Details',
      description: 'Fill in the amount of Flash USDT you want to purchase and provide your wallet address where you\'ll receive the funds.'
    },
    {
      icon: <ShieldIcon size={48} color="#00d4ff" />,
      number: '03',
      title: 'Make Payment',
      description: 'Complete the payment using your selected network. Upload your transaction screenshot and hash for verification.'
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
          <path d="M9 11l3 3L22 4" stroke="#00d4ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" stroke="#00d4ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      number: '04',
      title: 'Receive Flash USDT',
      description: 'After verification, your Flash USDT will be delivered to your wallet within 30 minutes to 1 hour. Track your order status via email.'
    }
  ];

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="container">
        <div className="section-header">
          <h2>HOW SHOPUSDT WORKS</h2>
          <p className="subtitle">
            Get your Flash USDT in 4 simple steps. Fast, secure, and hassle-free transactions.
          </p>
        </div>

        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={index} className="step-card">
              <div className="step-header">
                <div className="step-icon-wrapper">
                  {step.icon}
                </div>
                <div className="step-number">{step.number}</div>
              </div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="step-connector">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12h14M12 5l7 7-7 7" stroke="url(#arrowGradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <defs>
                      <linearGradient id="arrowGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#00d4ff" />
                        <stop offset="100%" stopColor="#8a2be2" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="trust-section">
          <div className="trust-card">
            <div className="trust-icon">
              <ShieldIcon size={56} color="#10b981" />
            </div>
            <div className="trust-content">
              <h3>100% Secure & Trusted Platform</h3>
              <p>Your transactions are protected with bank-grade encryption. We prioritize security, transparency, and customer satisfaction.</p>
            </div>
          </div>
          
          <div className="features-grid">
            <div className="feature-item">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="#00d4ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 17l10 5 10-5M2 12l10 5 10-5" stroke="#00d4ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Multi-Network Support</span>
            </div>
            <div className="feature-item">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="#ffd700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Lightning Fast Delivery</span>
            </div>
            <div className="feature-item">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Secure Transactions</span>
            </div>
            <div className="feature-item">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2a10 10 0 100 20 10 10 0 000-20z" stroke="#8a2be2" strokeWidth="2"/>
                <path d="M12 6v6l4 2" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <span>24/7 Support</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
